"use client";

import React from "react";
import { RxChevronRight } from "react-icons/rx";

export function Layout474() {
  return (
    <section className="bg-wood-green text-white font-sans px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 items-center gap-12 md:grid-cols-2 md:gap-x-16">
          
          {/* FOTKA - Zkusil jsem tam dát object-contain, aby se neztrácela, pokud má jiný poměr stran */}
          <div className="flex justify-center items-center overflow-hidden rounded-lg">
            <img
              src="img/Image container2.png" 
              className="w-full h-auto object-cover"
              alt="Tesařství Šindelář - realizace"
            />
          </div>

          <div>
            <p className="mb-3 font-semibold md:mb-4 uppercase tracking-wider">Šindelář: Poctivé tesařské řemeslo</p>
            <h2 className="mb-5 text-[40px] font-bold font-serif leading-[1.1] md:text-[56px]">
            Roubené stavby a rekonstrukce památkových objektů.
            </h2>
            
            <p className="text-base md:text-lg leading-[1.6]">
            Tesařství Šindelář je rodinná firma ze severních čech, Úštěka, která navazuje na tři generace poctivého tesařského řemesla. Specializujeme se na výstavbu tradičních českých roubenek, rekonstrukce historických a památkově chráněných objektů a komplexní tesařské práce.
            </p>

            <div className="mt-6 flex flex-wrap gap-4 md:mt-8">
              {/* TADY TO OPRAVUJEME: Teď to sjede na id="o-nas", které je v Layout1 */}
              <a 
                href="#o-nas" 
                className="px-10 py-4 bg-white text-wood-green font-bold rounded-full hover:bg-wood-light transition-all inline-block text-center"
              >
                O nás
              </a>
              
              
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}